module.exports = __webpack_public_path__ + "static/venice-ac6a2f0d06dcf2d891786f0d58a49151.png";